import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, ViewChild, ViewChildren, QueryList, viewChild, ElementRef, AfterViewInit, ChangeDetectionStrategy, Injector, afterNextRender } from '@angular/core';
import { FormArray, FormGroup, FormControl, FormBuilder, AbstractControl, ControlContainer, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { A11yModule } from '@angular/cdk/a11y';
import { CdkTextareaAutosize, TextFieldModule } from '@angular/cdk/text-field';

import { MatDialog, MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { ProductsComponent } from '../../products/products.component';
import { ProductsService } from '@app/sales/products/products.service';
import { ValuesService } from '@app/common/values/values.service';
import { PaymentService } from '@app/sales/payment/payment.service';
import { QuotationService } from '@app/sales/quotation/quotation.service';
import { AlertService } from '@app/shared/alert.service';
import { LoginService } from '@app/common/login.service';
import { CASH_NEEDS_DRAWER, cashFamilyOf, isPosStation } from '@app/sales/reglement/reglement.models';
import { Sales_payment, Sales_order_l, roundHalfAway, lineEcopartTaxx, lineNetTaxx, packPriceLabel, servedEcopartQty, vatTotals } from '@app/shared/_models/sales';
import { SearchProductComponent } from '@app/shared/search-product/search-product.component';
import { ScanResult, Udi, splitQtyPrefix, looksLikeFreeText, scanLabel, udiFromScan, sameUdi, udiLabel, scanRejection } from '@app/shared/_models/scan';
import { Sales_receivable, Sales_receivable_payment } from '@app/shared/_models/sales';

import { C_value, ActionBarStatus } from '@app/shared/_models/common';
import { calc_margin, round_currency } from '@app/shared/util';
//import * as constants from "@app/shared/constants";
import { SalesOrderState, OrderLineType } from '@app/shared/constants-server';
import { DocType, salesOrderLabels, salesOrderColors, isOrderLineEditable, isSealedOrder, C_CUF_CONFIGURATION_VALUE, C_CUF_CONFIGURATION, C_PAYMENT_METHOD, C_VALUES_UOM } from '@app/shared/constants';
import { BehaviorSubject, Observable, pipe, first, Subscription, forkJoin, of, timer, map, skip, fromEvent, startWith } from 'rxjs';
import * as constants from '@app/shared/constants';
import { Sales_tax } from '@app/shared/_models/sales';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { ConfigurationComponent } from '@app/sales/configuration/configuration.component';
import { FormatCurrencyPipe } from '@app/shared/pipes/format-currency.pipe';
import { InputPriceComponent } from '@app/shared/input-price/input-price.component';
import { SmartSelectComponent } from '@app/shared/smart-select/smart-select.component';
import { SmartInputComponent } from '@app/shared/smart-input/smart-input.component';

import { SelectPackagingQty } from '@app/sales/products/select-packaging-qty/selectPackagingQty.component';
import { Product, ProductPackagingVal, SalesPartnerpriceL } from '@app/shared/_models/product';
import { NotSellingDialog } from '@app/sales/products/not-selling/notSellingDialog.component';
import { NoPriceDialog, NoPriceDialogData, NoPriceDialogResult } from '@app/sales/products/no-price/noPriceDialog.component';
import Swal from 'sweetalert2';
import { PrintService } from '@app/shared/print.service';
import { SubstitutePaymentDialogComponent, SubstitutePaymentDialogData } from '../substitute-payment-dialog/substitute-payment-dialog.component';
import { UseAvoirDialogComponent, UseAvoirDialogData } from '../use-avoir-dialog/use-avoir-dialog.component';

@Component({
  selector: 'app-quotationgeneral',
  templateUrl: './quotationgeneral.component.html',
  styleUrls: ['./quotationgeneral.component.scss'],
  imports: [InputPriceComponent, SearchProductComponent, SmartSelectComponent, SmartInputComponent, FormsModule, A11yModule, TextFieldModule, ReactiveFormsModule, RouterLink, MatButtonModule, MatTooltipModule, MatIconModule, FormatCurrencyPipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class QuotationgeneralComponent implements OnInit, OnDestroy, AfterViewInit {
  formGroup!: FormGroup; // Inherited from parent
  // payformGroup!: FormGroup;						// Payment form group (local)
  userpriceinput: FormControl = new FormControl('');
  linetype: FormControl<OrderLineType> = new FormControl<OrderLineType>(OrderLineType.ITEM, { nonNullable: true });
  readonly lineTypes = [
    { id: 'ITEM', value: OrderLineType.ITEM, label: 'Article' },
    { id: 'ITEM_RETURN', value: OrderLineType.ITEM_RETURN, label: 'Retour Article' },
  ];
  paymenttype: FormControl = new FormControl<number>(1); // 1 = Carte bancaire (c_values 7), présélection de la caisse
  paymentinput: FormControl = new FormControl<number | undefined>(undefined);
  paymentdataComment: FormControl = new FormControl('');
  paymentmethods: C_value[] = [];
  packaging: C_value[] = [];
  strategyDiscount: C_value[] = [];
  map_paymentmethods = new Map();
  get paymentMethodItems() {
    return this.paymentmethods.filter(pm => pm.id !== -1 && pm.is_active !== false); // map_paymentmethods garde les inactifs pour l'historique
  }
  private cashIds: number[] = [];
  readonly cashNeedsDrawer = CASH_NEEDS_DRAWER;
  // Hors caisse, la famille espèces reste listée mais grisée (JP 04/10) ; fonction fléchée : smart-select l'appelle détachée (bindDisabled).
  readonly isCashLocked = (pm: C_value): boolean => !this.hasDrawer && this.cashIds.includes(pm.id!);
  nbitems: number = 0;
  nbpackagings: number = 0;
  lineFlatDiscounts: number[] = [];
  linePercentDiscounts: number[] = [];
  remainder: number = 0;
  payed: number = 0;
  change: number = 0;
  quotationSubscription!: Subscription;
  configurationSubscription!: Subscription;
  customer: any; // Customer object, set by
  public searchinputfocus: boolean = false;
  public C_CUF_CONFIGURATION_VALUE = C_CUF_CONFIGURATION_VALUE.toString();
  public C_CUF_CONFIGURATION = C_CUF_CONFIGURATION.toString();
  public readonly SalesOrderHelper = SalesOrderHelper;
  public SalesOrderState = SalesOrderState;
  public readonly DocType = DocType;
  public readonly OrderLineType = OrderLineType;

  @Input() loadOrderEventsSubject$!: Observable<FormGroup>; // Parent order was loaded
  @Input() loadCustomerEventsSubject$!: Observable<any>; // Parent customer was changed
  //@Input() periods: Array<SafePeriod> = [];												// Periods; -- 0:Year, 1:Month, 2:Day
  @Input() actionBarState$!: BehaviorSubject<ActionBarStatus>;
  @Input() group_packagings: boolean = false;

  @Input()
  set is_ht(value: boolean) {
    this._is_ht$.next(value);
  }
  get is_ht(): boolean {
    return this._is_ht$.getValue();
  }
  private readonly _is_ht$ = new BehaviorSubject<boolean>(false);
  private isHtSubscription!: Subscription;

  private eventsSubscription!: Subscription;
  private customerEventsSubscription!: Subscription;
  private formGroupChangeSubscription!: Subscription;
  private memoAutosizesSubscription!: Subscription;
  @Output('onSubmit') onSubmit: EventEmitter<any> = new EventEmitter(); // To send submit to parent
  @Output() remainderChange = new EventEmitter<number>();
  @Output() onReload = new EventEmitter<void>();
  @ViewChild('searchProduct') public searchProductElement!: SearchProductComponent;
  @ViewChildren(CdkTextareaAutosize) private memoAutosizes!: QueryList<CdkTextareaAutosize>;

  public loadOrderEventsSubject: BehaviorSubject<FormGroup> = new BehaviorSubject<FormGroup>(this.formGroup); // To receive load order event

  constructor(
    private paymentService: PaymentService,
    private valuesService: ValuesService,
    private productsService: ProductsService,
    public dialog: MatDialog,
    private fb: FormBuilder,
    public controlContainer: ControlContainer,
    private http: HttpClient,
    private quotationservice: QuotationService,
    private alertService: AlertService,
    private injector: Injector,
    private loginService: LoginService,
    private printService: PrintService,
  ) {}

  ngOnInit(): void {
    this.isHtSubscription = this._is_ht$.subscribe(is_ht => {
      // console.log('[quotationgeneral] is_ht changed:', is_ht);
      if (this.formGroup) this.initLineDiscounts();
    });

    this.quotationSubscription = this.quotationservice.subject.asObservable().subscribe(data => {
      this.addLine(data.product, data.qty, null);
    });

    this.valuesService
      .getValues$(C_PAYMENT_METHOD) // Get payment methods
      .subscribe((data: any) => {
        this.paymentmethods = data;
        this.paymentmethods.map(a => {
          this.map_paymentmethods.set(a.id, a.name); // Exclude non positive keys from list
        });
        this.cashIds = cashFamilyOf(data)?.ids ?? [];
        if (this.isCashLocked({ id: this.paymenttype.value })) this.paymenttype.setValue(this.paymentMethodItems.find(pm => !this.isCashLocked(pm))?.id ?? null);
      });
    this.valuesService
      .getValues$(C_VALUES_UOM) // Get packaging
      .subscribe((data: any) => {
        this.packaging = data;
      });
    this.valuesService
      .getValues$(constants.C_VALUES_TYPE_DISCOUNT) // Get Strategy discount (type de remise)
      .subscribe((data: any) => {
        this.strategyDiscount = data;
        // console.log('this.strategyDiscount', this.strategyDiscount);
      });

    //this.actionBarState$.next(this.actionBarState$.getValue().setHasChange());	// TODO subscribe for formgroup change

    this.eventsSubscription = this.loadOrderEventsSubject$.subscribe((formGroup: FormGroup) => {
      // Triggered on Order loading
      //this.formGroup = this.controlContainer.control as FormGroup;							// WARNING controlContainer is NOT updated =>
      this.loadOrderEventsSubject.next(formGroup); // Emit a loadorder event to child components

      this.formGroup = formGroup;
      this.customer = formGroup.get('lnk_customer')?.value; // lnk_customer is disabled on ne peut donc pas y accéder par fg.value.lnk...
      // formGroup is sent by parent
      //console.log("[quotationgeneral] loadOrderEventsSubject$, Received id_order / state:" + id_order + ' / ' + this.formGroup.value.state + ' / ' + this.controlContainer?.control?.get('state')?.value);
      // console.log("[quotationgeneral] loadOrderEventsSubject$, Received state: id / formGroup.state / controlContainer.state: " + this.formGroup.value.id + ' / ' + this.formGroup.value.state + ' / ' + this.controlContainer?.control?.get('state')?.value);
      if (this.formGroup.value.id > 0) {
        this.processTotal();
        this.processRemainder();
      }
      this.initLineDiscounts();
      // this.formGroupChangeSubscription = this.formGroup.valueChanges.subscribe(_val=>{this.actionBarState$.next( this.actionBarState$.getValue().setHasChange())});
      this.formGroupChangeSubscription = this.formGroup.valueChanges.subscribe(_val => {
        // Adjust actionbar acording to order state
        if (_val && ((_val.lines && _val.lines.length) || _val.customer) && !(_val.lnk_delivery && _val.lnk_delivery.mode && parseInt(_val.lnk_delivery.mode) === 4)) {
          this.actionBarState$.next(new ActionBarStatus(true, true));
        } else if (!_val || (!(_val.lines && _val.lines.length) && !_val.customer)) {
          this.actionBarState$.next(new ActionBarStatus(false, true));
        }
      });
      // console.log(' salut from inside subscription of load order');
      // this.searchElement!.nativeElement.focus()
    });
  }

  ngAfterViewInit(): void {
    this.customerEventsSubscription = this.loadCustomerEventsSubject$.pipe(skip(1)).subscribe({
      // First subject is always null, skip it
      next: (customer: any) => {
        // FIXME Do NOT trigger on order loading!
        this.customer = customer;
        this.customerChange();
        // this.searchProductElement.focus(); // TODO Won't work on fse dialog return
        //  this.searchElement!.nativeElement.focus(); // Set focus on search input on article search input
      },
    });

    // Même remesure que rentgeneral : la CDK mesure un mémo à la création de sa ligne, avant les largeurs finales du tableau (table-layout auto).
    this.memoAutosizesSubscription = this.memoAutosizes.changes
      .pipe(startWith(null))
      .subscribe(() => afterNextRender(() => this.memoAutosizes.forEach((a) => a.resizeToFitContent(true)), { injector: this.injector }));
  }

  blurEmitterSearchProduct(searchProduct: string) {
    // console.log('blurEmitterSearchProduct', searchProduct);
    // this.searchinputfocus = event;
    // this.searchinput.value = searchProduct;
    this.scanOrSearchProduct(searchProduct);
  }

  selectProductEmitter(data: any) {
    // console.log(' salut from inside selectProductEmitter in quotationgeneral', data);
    if (!data) return;

    if (data.hasOwnProperty('ppv') && data.hasOwnProperty('qty')) {
      this.addLine(data.ppv, data.qty, null);
    } else if (data instanceof Product || data.id) {
      this.openSelectPackagingQty(data);
    }
  }

  private openSelectPackagingQty(product: Product) {
    this.dialog
      .open(SelectPackagingQty, { width: '60%', data: product })
      .afterClosed()
      .subscribe(resultSelectPackagingAndQty => {
        if (resultSelectPackagingAndQty?.hasOwnProperty('ppv') && resultSelectPackagingAndQty?.hasOwnProperty('qty')) {
          this.addLine(resultSelectPackagingAndQty.ppv, resultSelectPackagingAndQty.qty, null);
          // console.log('resultSelectPackagingAndQty', resultSelectPackagingAndQty);
        }
      });
  }

  // Entrée/blur du champ produit : « 3x… » = quantité de saisie, le reste part tel quel à /search/scan (EAN, GS1, HIBC, Digital Link,
  // code interne). Rien trouvé ET rien de décodable = texte libre → dialogue de recherche par nom, comme avant.
  scanOrSearchProduct(searchProduct: string): void {
    if (!searchProduct) return; // Input field is empty => NOP
    const text: string = searchProduct.toString().trim();
    const { qty, raw } = splitQtyPrefix(text);
    if (!raw) return;

    const pricelists = this.customer?.data?.pricelists ?? this.customer?.lnk_partnerprices?.map((spp: { id: any }) => spp.id);
    let subscription = this.productsService.search_scan(raw, pricelists).subscribe({
      next: (res: ScanResult) => {
        subscription.unsubscribe();
        const rejection = scanRejection(res.scan, raw);
        if (res.ppv) {
          // addLine détecte lui-même un article configurable et ouvre la boîte de configuration ; le lot/péremption/série lus partent avec la ligne.
          const udi = udiFromScan(res.scan);
          // AI 02 sans AI 01 (étiquette de carton) : le ppv est celui de l'article CONTENU, la quantité est l'AI 37.
          const isContent = !res.scan.gtin && !!res.scan.content;
          if (isContent && !res.scan.count) {
            this.alertService.warn('Étiquette de carton sans quantité : scannez le code-barres de l’article');
            this.searchProductElement.focus();
            return;
          }
          let lineQty = isContent ? qty * res.scan.count! : qty;
          if (udi?.serial) {
            // Un n° de série désigne UNE unité : refusé s'il est déjà sur la pièce, toujours en qté 1.
            if (this.hasSerial(udi)) {
              this.alertService.warn(`N° de série ${udi.serial} déjà sur la pièce`);
              this.searchProductElement.focus();
              return;
            }
            if (lineQty !== 1) this.alertService.warn('Un n° de série désigne une seule unité : quantité ramenée à 1');
            lineQty = 1;
          }
          this.addLine(res.ppv, lineQty, udi ? { udi } : null);
        } else if (rejection) {
          // Lien de fournisseur, carton, étiquette secondaire : pas un code produit, on le dit et on attend un autre symbole.
          this.alertService.warn(rejection);
          this.searchProductElement.focus();
        } else if (looksLikeFreeText(res.scan, raw)) {
          this.openProductDialog(text);
        } else {
          // Code reconnu (ou nombre nu) mais absent du catalogue.
          this.alertService.warn('Code barre non trouvé : ' + scanLabel(res.scan, raw));
          this.searchProductElement.focus();
        }
      },
      error: e => {
        console.error('ERREUR Serveur : ', e.error);
        this.alertService.error('ERREUR Serveur : ' + e.error); // TEMPLATE subscribe call
        this.searchProductElement.focus();
      },
    });
  }

  private hasSerial(udi: Udi): boolean {
    return this.lines.controls.some(l => {
      const u: Udi | undefined = l.get('data')?.value?.udi;
      return u?.serial === udi.serial && (u?.gtin14 ?? null) === (udi.gtin14 ?? null);
    });
  }

  checkIsSold(ppv: any, qty: number, data: any): boolean {
    // Vérification du prix avant la vérification de vendabilité
    const hasPriceTaxi = (ppv?.lnk_product?.price_taxi ?? 0) > 0 || (ppv?.price_discounted_taxi ?? 0) > 0;
    const hasPriceTaxx = (ppv?.lnk_product?.price_taxx ?? 0) > 0 || (ppv?.price_discounted_taxx ?? 0) > 0;
    if (!hasPriceTaxi && !hasPriceTaxx) {
      this.dialog
        .open(NoPriceDialog, {
          width: '60%',
          // Le prix saisi est celui d'UNE unité de base ; le dialogue rappelle le conditionnement scanné (carton de 4 paquets…) pour qu'on ne saisisse pas le prix du carton.
          data: {
            productName: ppv?.lnk_product?.name,
            productId: ppv?.lnk_product?.id,
            is_ht: this.is_ht,
            packagingName: this.getPackagingName(ppv),
            packagingUnitName: this.packaging.find(p => p.id == ppv?.packaging)?.name,
            baseUnitName: this.packaging.find(p => p.id == ppv?.lnk_product?.lnk_template?.baseuom)?.name,
            qtybaseuom: parseFloat(ppv?.qtybaseuom) || 1,
            // L'article 1 (DIVERS) passe par le dialogue comme les autres, mais tout prix y est accepté (0 et négatif compris).
            freePrice: ppv?.lnk_product?.id == 1,
          } as NoPriceDialogData,
        })
        .afterClosed()
        .subscribe((result: NoPriceDialogResult | null) => {
          if (result) {
            const vatRate = parseFloat(ppv?.lnk_product?.lnk_template?.vat_rate) || 0;
            // Conversion NON arrondie : addLine arrondit le prix du conditionnement à 4 décimales, sinon 14,50 TTC × 4 donnerait 57,98.
            if (result.is_ht) {
              ppv.lnk_product.price_taxx = result.price;
              ppv.lnk_product.price_taxi = result.price * (1 + vatRate / 100);
            } else {
              ppv.lnk_product.price_taxi = result.price;
              ppv.lnk_product.price_taxx = result.price / (1 + vatRate / 100);
            }
            this.addLine(ppv, qty, data, true);
          }
        });
      return false;
    }

    if (ppv && (!ppv.is_sellable || (ppv.lnk_product && !ppv.lnk_product.is_sold))) {
      // console.log('Salut from : inside if');
      const notSellingDialogRef = this.dialog.open(NotSellingDialog, { width: '60%', data: ppv });
      notSellingDialogRef.afterClosed().subscribe(result => {
        // console.log('result', result);
        if (result) {
          this.addLine(ppv, qty, data, true);
        }
      });
      return false;
    }
    return true;
  }

  addLine(ppv: any, qty: number, data: any, forceSellin_notSellingProduct: boolean = false): boolean {
    // Add a line from product_packaging_val API to formgroup

    // Point d'entrée UNIQUE de tous les ajouts de ligne de VENTE (hors location): code-barres, dialogue produit,
    // choix du conditionnement, produits liés d'une location, et surtout l'abonnement à
    // quotationservice.subject (ngOnInit) qui vient de l'historique client et ne passe par
    // AUCUN @if du template. La garde est donc ici, pas dans les appelants.
    if (!isOrderLineEditable(this.formGroup?.value?.state, this.formGroup?.value?.doc_type)) return false;
    // Location (JP 30/10) : le dossier ne porte que le loué ; une vente ajoutée ici (produit lié du contrat…) part à l'enregistrement dans sa commande de vente (#31).
    if (this.formGroup?.value?.doc_type === DocType.LOCATION) this.alertService.info("Article vendu : il partira dans la commande de vente du dossier à l'enregistrement.");

    if (!forceSellin_notSellingProduct && !this.checkIsSold(ppv, qty, data)) {
      // si on a un produit non vendable on ouvre la boite de dialogue dans checkIsSold on casse la fonction addLine lors du deuxième passage pour ne pas entrer dans cette boucle on passe forceSellin_notSellingProduct a true
      return false; // on casse cette execution de fonction c est checkIsSold qui va l executer a nouveau après la fermeture de la boite de dialogue
    }

    let [is_product_sane, msg] = this.is_product_sane(ppv);
    if (!is_product_sane) {
      console.error(msg);
      this.alertService.error('ERREUR : ' + msg);
      return false;
    }
    // if(ppv.lnk_product.hasOwnProperty('data') && ppv.lnk_product.data.hasOwnProperty('cufs') && ppv.lnk_product.data.cufs.hasOwnProperty(constants.C_CUF_CONFIGURATION.toString())         ){
    if (constants.C_CUF_CONFIGURATION.toString() in (ppv.lnk_product.lnk_template.data?.cufs ?? {})) {
      data = { ...data, cufs: { ...data?.cufs, [constants.C_CUF_CONFIGURATION.toString()]: ppv.lnk_product.lnk_template.data.cufs[constants.C_CUF_CONFIGURATION.toString()] } };
    }
    // D1 : la ligne porte les prix d'UN conditionnement (catalogue par unité de base × colisage) ; qty compte des conditionnements.
    const pack = parseFloat(ppv.qtybaseuom) || 1;
    const vat_rate = parseFloat(ppv.lnk_product.lnk_template.vat_rate) || 0;
    const uprice_taxx = roundHalfAway(Number(ppv.lnk_product.price_taxx) * pack, 4);
    const uprice_taxi = roundHalfAway(Number(ppv.lnk_product.price_taxi) * pack, 4);
    const unet_taxi = roundHalfAway(Number(ppv.price_discounted_taxi ? ppv.price_discounted_taxi : ppv.lnk_product.price_taxi) * pack, 4); // Apply discounted price if any
    const unet_taxx = roundHalfAway(Number(ppv.price_discounted_taxx ? ppv.price_discounted_taxx : ppv.lnk_product.price_taxx) * pack, 4);
    const isReturn = this.linetype.value === OrderLineType.ITEM_RETURN;
    const finalQty = isReturn ? -Math.abs(Number(qty) || 1) : Math.abs(Number(qty) || 1);
    const net_taxx = lineNetTaxx(finalQty, unet_taxx); // le prix catalogue inclut déjà l'éco-participation

    const isConfigurable = constants.C_CUF_CONFIGURATION.toString() in (ppv.lnk_product.lnk_template.data?.cufs ?? {});
    if (this.group_packagings && !isConfigurable) {
      let lastIndex = -1;
      this.lines.controls.forEach((line, i) => {
        // Une ligne = un (conditionnement, lot, péremption, série, type) : un retour ne fusionne jamais avec une vente.
        if (
          line.get('typ')?.value === this.linetype.value &&
          line.get('product')?.value === ppv.product &&
          line.get('packaging_qtybaseuom')?.value === parseFloat(ppv.qtybaseuom) &&
          sameUdi(line.get('data')?.value?.udi, data?.udi)
        ) {
          lastIndex = i;
        }
      });
      if (lastIndex !== -1) {
        const qtyCtrl = this.lines.at(lastIndex).get('qty');
        qtyCtrl?.setValue((Number(qtyCtrl.value) || 0) + finalQty);
        this.triggerHighlight(lastIndex);
        this.searchProductElement.focus();
        this.processTotal();
        if (isReturn) {
          this.linetype.setValue(OrderLineType.ITEM);
        }
        return true;
      }
    }

    this.lines.push(
      this.fb.group({
        id: 0, // API needs an id
        id_order: 0,
        seq: this.highestSeq() + 1,
        typ: this.linetype.value,
        product: [ppv.product],
        template: [ppv.lnk_product.template],
        qty: [finalQty],
        product_name: [ppv.lnk_product.name], // Crashed once, why?
        ppv: [ppv.id], // Le conditionnement vendu — l'id, plus le code-barres
        vat: [ppv.lnk_product.lnk_template.vat],
        vat_rate: [parseFloat(ppv.lnk_product.lnk_template.vat_rate)],
        uprice_taxx: new FormControl<number>(uprice_taxx),
        uprice_taxi: new FormControl<number>(uprice_taxi), // Base price
        unet_taxx: new FormControl<number>(unet_taxx),
        unet_taxi: new FormControl<number>(unet_taxi), // Net price ie discounted price
        net_taxx: new FormControl<number>(net_taxx), // Montant de la ligne, recalculé par processTotal
        net_taxi: new FormControl<number>(roundHalfAway(net_taxx * (1 + vat_rate / 100), 2)),
        spl: [ppv.lnk_product.spl],

        // `packaging_name` n'existe pas sur un ProductPackagingVal : seul l'historique client le pose, en rejouant
        // une ligne vendue avec le libellé exact d'alors (salehistory.addproduct) ; le repli est le cas normal.
        packaging_name: [ppv.packaging_name ?? this.getPackagingName(ppv)],
        packaging_qtybaseuom: [parseFloat(ppv.qtybaseuom)],
        data: data,
        memo: [''],
        ecoparts: [ppv.lnk_product.lnk_ecoparts],
        lnk_spl: this.find_lnk_spl(ppv), // utilisé uniquement pour l'affichage n'est pas sauvegardé ni envoyé au serveur
      }),
    );
    this.triggerHighlight(this.lines.length - 1);
    this.searchProductElement.focus();
    this.processTotal();
    this.initLineDiscounts();

    if (isReturn) {
      this.linetype.setValue(OrderLineType.ITEM);
    }

    if (ppv && ppv.lnk_product && ppv.lnk_product.lnk_template?.data?.cufs && ppv.lnk_product.lnk_template.data.cufs.hasOwnProperty(constants.C_CUF_CONFIGURATION.toString())) {
      this.openConfigurationDialog(ppv?.lnk_product?.lnk_template?.data?.cufs[constants.C_CUF_CONFIGURATION], this.lines.at(-1).value, (data: any) => {}); //no call back given
    }

    // console.log(ppv)
    // console.log('this.lines', this.lines);
    return true;
  }

  udiLabel(line: AbstractControl): string {
    return udiLabel(line.get('data')?.value?.udi);
  }

  highestSeq(): number {
    const lines = this.linesControls;
    if (!lines || lines.length === 0) {
      return 0;
    }
    let maxSeq = 0;
    lines.forEach(line => {
      // console.log('value of line =  ', line.value);
      const seq = line.get('seq')?.value ?? 0;
      if (typeof seq === 'number' && seq > maxSeq) {
        maxSeq = seq;
      }
      // important lorque un produit est configurable il "réserve" les seq dont il a besoin ici c'est ce que l'on va regarder
      if (line.value && line.value.data && line.value.data.cufs && line.value.data.cufs[constants.C_CUF_CONFIGURATION_VALUE] && Array.isArray(line.value.data.cufs[constants.C_CUF_CONFIGURATION_VALUE])) {
        line.value.data.cufs[constants.C_CUF_CONFIGURATION_VALUE].forEach(prod_conf => {
          // console.log('value of prod_conf =  ', prod_conf);
          maxSeq = Math.max(maxSeq, prod_conf.seq);
        });
      }
    });
    return maxSeq;
  }

  is_product_sane(ppv: any): [boolean, string | undefined] {
    // Check a few requested properties of product
    let msg: string | undefined = undefined;
    if (!ppv.hasOwnProperty('product') || !ppv.hasOwnProperty('lnk_product') || !ppv.lnk_product.hasOwnProperty('lnk_template')) {
      msg = 'Incohérence dans les propriétés du produit';
    } else if (!ppv.lnk_product.lnk_template.hasOwnProperty('vat') || !ppv.lnk_product.lnk_template.hasOwnProperty('vat_rate')) {
      msg = 'Pas de TVA définie sur le produit';
    }
    return [msg === undefined, msg];
  }

  getPackagingName(ppv: any): string {
    let packaging_name = '';
    // console.log('this.packaging', JSON.stringify(this.packaging));
    if (this.packaging && this.packaging.length > 0 && this.packaging.find(p => p.id == ppv.packaging)) {
      packaging_name += this.packaging.find(p => p.id == ppv.packaging)?.name;
      // console.log('ppv', ppv);
      if (ppv.qtybaseuom && ppv.qtybaseuom > 1 && ppv.lnk_product.lnk_template.baseuom && ppv.lnk_product.lnk_template.baseuom != ppv.packaging && this.packaging.find(p => p.id == ppv.lnk_product.lnk_template.baseuom)) {
        packaging_name += ' de ' + ppv.qtybaseuom + ' ' + this.packaging.find(p => p.id == ppv.lnk_product.lnk_template.baseuom)?.name + 's';
      }
    }
    return packaging_name;
  }

  // Pose sur la ligne le conditionnement PAR DÉFAUT du produit — pour les chemins qui partent d'un Product (composants
  // de configuration, ventes additionnelles) ; addLine tient déjà le ppv choisi. Asynchrone : un échec laisse ppv à null.
  private patchDefaultPpv(line: AbstractControl, product_id: number | undefined): void {
    this.productsService.default_ppv_id(product_id).subscribe(ppv_id => {
      if (ppv_id) line.patchValue({ ppv: ppv_id });
    });
  }

  deleteLine(line: any): void {
    // console.log('Valeur de  line = ', line);
    // Le bouton corbeille n'était gardé que par `typ !== 5` : aucun test d'état. Il était donc
    // actif sur une pièce reprise (comme sur une commande facturée ou soldée), et son clic
    // retirait réellement la ligne du FormArray — le formulaire divergeait de la base jusqu'au
    // rechargement suivant. Garde ici EN PLUS du masquage du bouton : deleteLine est aussi
    // appelée par openConfigurationDialog.
    if (!isOrderLineEditable(this.formGroup?.value?.state, this.formGroup?.value?.doc_type)) return;
    if (this.is_configurable_line(line)) {
      // on est une ligne configurable on doit supprimer les lignes enfants
      line.value.data.cufs[constants.C_CUF_CONFIGURATION_VALUE].forEach((prod_conf: any) => {
        let index = this.linesControls.findIndex((l: any) => l.value.seq == prod_conf.seq);
        if (index > -1) {
          this.lines.removeAt(index);
        }
      });
    }
    this.lines.removeAt(this.linesControls.findIndex((l: any) => l.value.seq == line.value.seq));
    this.processTotal();
    this.initLineDiscounts();
  }

  // todo move this function to search-product component
  openProductDialog(searchProduc: string): void {
    // Open product lookup page as a modal dialog
    if (!searchProduc || searchProduc.trim().length === 0) {
      return;
    }
    const dialogRef = this.dialog.open(ProductsComponent, {
      // here we have to specify that we can't select template product and when we click on a product we have to return the quotation
      width: '80%',
      height: '80%',
      data: { mode: 'DIALOG', searchname: searchProduc },
    });

    dialogRef.afterClosed().subscribe(ret => {
      // result could be undefined
      // console.log('ret=', JSON.stringify(ret), ret);
      if (ret && ret.hasOwnProperty('ppv') && ret.hasOwnProperty('qty')) {
        this.addLine(ret.ppv, ret.qty, null);
      }
      this.searchProductElement.focus();

      // this.searchinput.patchValue(ret);
      // if (ret) {
      // 	this.search_productpackaging('jpid');	// Looking for a product id => index jpid:
      // }
    });
  }

  // Montants d'une ligne EN SAISIE, arithmétique du serveur : net = round(qty × unet, 2), éco-participation déjà dans unet, jamais × colisage.
  private refreshLineAmounts(line: AbstractControl): void {
    const qty = Number(line.get('qty')?.value) || 0;
    const rate = Number(line.get('vat_rate')?.value) || 0;
    const net_taxx = lineNetTaxx(qty, line.get('unet_taxx')?.value);
    line.patchValue({ net_taxx, net_taxi: roundHalfAway(net_taxx * (1 + rate / 100), 2) }, { emitEvent: false });
  }

  processTotal(): void {
    // En-tête comme le serveur (vatTotals : base par taux, TVA arrondie par taux) ; les lignes de location du contrat n'y entrent pas.
    const editable = isOrderLineEditable(this.formGroup?.value?.state, this.formGroup?.value?.doc_type);
    const visible = this.lines.controls.filter(line => this.is_line_visible(line));

    this.nbitems = 0;
    this.nbpackagings = 0;
    for (const line of visible) {
      if (editable) this.refreshLineAmounts(line); // une ligne d'une pièce figée garde les montants servis
      const qty = Number(line.get('qty')?.value) || 0;
      this.nbpackagings += qty;
      this.nbitems += qty * (Number(line.get('packaging_qtybaseuom')?.value) || 1);
    }

    if (!editable) return; // pièce figée : l'en-tête servi fait foi
    const totals = vatTotals(visible.map(line => ({ vat_rate: line.get('vat_rate')?.value, net_taxx: line.get('net_taxx')?.value })));
    this.formGroup.get('amount_taxx')?.patchValue(totals.amount_taxx);
    this.formGroup.get('amount_taxi')?.patchValue(totals.amount_taxi);
  }

  // Montant affiché d'une ligne : recalculé en direct pendant la saisie, servi tel quel sinon.
  lineAmount(line: AbstractControl, ttc: boolean): number {
    if (!this.isLineEditable) return Number(line.get(ttc ? 'net_taxi' : 'net_taxx')?.value) || 0;
    const qty = Number(line.get('qty')?.value) || 0;
    const rate = Number(line.get('vat_rate')?.value) || 0;
    const net_taxx = lineNetTaxx(qty, line.get('unet_taxx')?.value);
    return ttc ? roundHalfAway(net_taxx * (1 + rate / 100), 2) : net_taxx;
  }

  // Prix net d'une unité de base, pour comparer un carton à l'unité ; indicatif, jamais envoyé.
  baseUnitNet(line: AbstractControl, ttc: boolean): number {
    const pack = Number(line.get('packaging_qtybaseuom')?.value) || 1;
    return (Number(line.get(ttc ? 'unet_taxi' : 'unet_taxx')?.value) || 0) / pack;
  }

  packPriceLabel(line: AbstractControl): string {
    return packPriceLabel(line.value);
  }

  // Update this.payed & this.remainder
  // TODO check this out. receivable refactoring
  processRemainder(): void {
    this.payed = 0; // WARNING computed in cents to prevent weird float behaviours
    let expected = 0;

    const customerReceivable = this.formGroup.value.lnk_receivables?.find((r: any) => r.payer_id === this.formGroup.value.customer);

    if (customerReceivable && this.isReadOnly) {
      // PIÈCE REPRISE : le réglé fait foi par le GRAND LIVRE (sales_receivable.amount_paid),
      // pas par les lignes de règlement. La reprise pose amount_paid depuis l'en-tête de la
      // facture orthop (mtt − dû) alors que les affectations arrivent d'une phase distincte :
      // sommer lnk_receivable_payments afficherait 0 € réglé, donc la totalité en « à régler »,
      // sur une facture pourtant soldée. Aucun règlement en attente ici (la saisie est fermée),
      // la lecture directe du grand livre est donc exacte — et c'est la valeur que le serveur
      // utilise lui-même dans ses gardes.
      expected = parseFloat(customerReceivable.amount_expected || 0) * 100;
      this.payed = parseFloat(customerReceivable.amount_paid || 0) * 100;
    } else if (customerReceivable) {
      expected = parseFloat(customerReceivable.amount_expected || 0) * 100;
      const payments = customerReceivable.lnk_receivable_payments || [];
      for (let i = 0; i < payments.length; i++) {
        if (payments[i].lnk_payment?.action !== 'CANCEL') {
          this.payed += parseFloat(payments[i].amount) * 100;
        }
      }
    } else if (this.formGroup.value.doc_type === DocType.FACTURE_ACOMPTE) {
      // Facture d'acompte : sans créance propre, scellée et encaissée dans la même transaction (take_deposit), donc soldée.
      expected = (this.formGroup.get('amount_taxi')?.value || 0) * 100;
      this.payed = expected;
    } else {
      expected = (this.formGroup.get('amount_taxi')?.value || 0) * 100;
    }

    let remainder = expected - this.payed;
    this.payed = Math.round(this.payed) / 100; // Back to €
    this.remainder = Math.round(remainder) / 100;
    this.remainderChange.emit(this.remainder);
  }

  get depositInfo(): { order_id: number; doc_ref?: string; amount?: number; c_attach_id?: number } | null {
    const data = this.formGroup?.get('data')?.value || this.formGroup?.value?.data;
    if (data?.deposit_order_id) {
      return {
        order_id: data.deposit_order_id,
        doc_ref: data.deposit_doc_ref,
        amount: data.deposit_amount,
        c_attach_id: data.deposit_c_attach_id,
      };
    }
    return null;
  }

  // Facture de solde scellée : la ligne de déduction rend l'en-tête NET de l'acompte, le retrancher encore le compterait deux fois.
  get isDepositDeducted(): boolean {
    return (this.formGroup?.value?.lines || []).some((l: any) => l?.typ === OrderLineType.DEPOSIT_DEDUCTION);
  }

  get paymentProgressPercent(): number {
    if (this.remainder < 0) return 0;
    if (this.remainder === 0) return 100;
    const total = this.payed + this.remainder;
    if (total <= 0) return this.payed !== 0 ? 100 : 0;
    return Math.min(100, Math.max(0, Math.round((this.payed / total) * 100)));
  }

  get isNegativeTotal(): boolean {
    return Number(this.formGroup?.get('amount_taxi')?.value || 0) < 0;
  }

  get absRemainder(): number {
    return Math.abs(this.remainder || this.formGroup?.value?.amount_taxi || 0);
  }

  onPriceQtyBlur(i: number): void {
    if (!isOrderLineEditable(this.formGroup?.value?.state, this.formGroup?.value?.doc_type)) return; // ex-SalesOrderHelper.isCreated : cf. note du helper
    const line = this.lines.at(i);
    if (line) {
      const typ = line.get('typ')?.value;
      const rawQty = Number(line.get('qty')?.value) || 0;
      if (typ === OrderLineType.ITEM_RETURN && rawQty > 0) {
        line.get('qty')?.setValue(-rawQty);
      } else if (typ === OrderLineType.ITEM && rawQty < 0) {
        this.alertService.warn('Un article vendu ne peut avoir une quantité négative. Utilisez le type « Retour Article ».');
        line.get('qty')?.setValue(Math.abs(rawQty));
      }
    }
    this.processTotal();
  }

  initLineDiscounts(): void {
    this.lineFlatDiscounts = [];
    this.linePercentDiscounts = [];
    for (let i = 0; i < this.lines.length; i++) {
      const line = this.lines.at(i);
      let uprice: number;
      let net: number;
      // Remise = prix du conditionnement avant/après remise (net_* est désormais le montant de la ligne).
      if (this.is_ht) {
        uprice = parseFloat(line.get('uprice_taxx')?.value) || 0;
        net = parseFloat(line.get('unet_taxx')?.value) || 0;
      } else {
        // console.log('Salut from : passage ici     ');
        uprice = parseFloat(line.get('uprice_taxi')?.value) || 0;
        net = parseFloat(line.get('unet_taxi')?.value) || 0;
      }
      // console.log('uprice', uprice);
      // console.log('net', net);
      const flat = round_currency(uprice - net);
      // console.log('flat', flat);
      const percent = uprice ? round_currency((flat / uprice) * 100, 2) : 0; // la remise en pourcent est indicative car on calcul de prix discount coté serveur du coup autant l'afficher avec 2 digit
      this.lineFlatDiscounts.push(flat);
      this.linePercentDiscounts.push(percent);
    }
  }

  onFlatDiscountChange(i: number, event: Event): void {
    if (!isOrderLineEditable(this.formGroup?.value?.state, this.formGroup?.value?.doc_type)) return; // ex-SalesOrderHelper.isCreated : cf. note du helper
    const value = parseFloat((event.target as HTMLInputElement).value) || 0;
    const line = this.lines.at(i);
    const uprice_taxi = parseFloat(line.get('uprice_taxi')?.value) || 0;
    const uprice_taxx = parseFloat(line.get('uprice_taxx')?.value) || 0;

    let net_taxi: number;
    let net_taxx: number;
    let percentdiscount: number;

    // Prix du conditionnement à 4 décimales (NUMERIC(14,4)) : un TTC saisi retombe juste une fois le HT relu.
    if (this.is_ht) {
      net_taxx = roundHalfAway(uprice_taxx - value, 4);
      net_taxi = uprice_taxx ? roundHalfAway((net_taxx * uprice_taxi) / uprice_taxx, 4) : 0;
      percentdiscount = uprice_taxx ? round_currency((value / uprice_taxx) * 100) : 0;
    } else {
      net_taxi = roundHalfAway(uprice_taxi - value, 4);
      net_taxx = uprice_taxi ? roundHalfAway((net_taxi * uprice_taxx) / uprice_taxi, 4) : 0;
      percentdiscount = uprice_taxi ? round_currency((value / uprice_taxi) * 100) : 0;
    }

    line.get('unet_taxi')!.setValue(net_taxi);
    line.get('unet_taxx')!.setValue(net_taxx);
    line.get('spl')?.setValue(null);
    (line as FormGroup).setControl('lnk_spl', new FormControl(null));
    this.lineFlatDiscounts[i] = value;
    this.linePercentDiscounts[i] = percentdiscount;
    // line.get('typ')!.setValue(2);
    this.processTotal();
  }

  onPercentDiscountChange(i: number, event: Event): void {
    if (!isOrderLineEditable(this.formGroup?.value?.state, this.formGroup?.value?.doc_type)) return; // ex-SalesOrderHelper.isCreated : cf. note du helper
    const value = parseFloat((event.target as HTMLInputElement).value) || 0;
    const line = this.lines.at(i);
    const uprice_taxi = parseFloat(line.get('uprice_taxi')?.value) || 0;
    const uprice_taxx = parseFloat(line.get('uprice_taxx')?.value) || 0;
    // console.log('value', value);
    // console.log('line', line);
    // console.log('uprice_taxi', uprice_taxi);
    // console.log('uprice_taxx', uprice_taxx);

    let net_taxi: number;
    let net_taxx: number;
    let flatdiscount: number;

    if (this.is_ht) {
      flatdiscount = round_currency((uprice_taxx * value) / 100);
      net_taxx = roundHalfAway(uprice_taxx - flatdiscount, 4);
      net_taxi = uprice_taxx ? roundHalfAway((net_taxx * uprice_taxi) / uprice_taxx, 4) : 0;
    } else {
      flatdiscount = round_currency((uprice_taxi * value) / 100);
      net_taxi = roundHalfAway(uprice_taxi - flatdiscount, 4);
      net_taxx = uprice_taxi ? roundHalfAway((net_taxi * uprice_taxx) / uprice_taxi, 4) : 0;
    }

    line.get('unet_taxi')!.setValue(net_taxi);
    line.get('unet_taxx')!.setValue(net_taxx);
    line.get('spl')?.setValue(null);
    (line as FormGroup).setControl('lnk_spl', new FormControl(null));
    this.lineFlatDiscounts[i] = flatdiscount;
    this.linePercentDiscounts[i] = value;
    // line.get('typ')!.setValue(2);
    this.processTotal();
  }

  onNetChange(i: number): void {
    if (!isOrderLineEditable(this.formGroup?.value?.state, this.formGroup?.value?.doc_type)) return; // ex-SalesOrderHelper.isCreated : cf. note du helper
    const line = this.lines.at(i);
    const uprice_taxi = parseFloat(line.get('uprice_taxi')?.value) || 0;
    const uprice_taxx = parseFloat(line.get('uprice_taxx')?.value) || 0;

    let net_taxi: number;
    let net_taxx: number;
    let flatdiscount: number;
    let percentdiscount: number;

    // Le champ saisi est le prix NET du conditionnement (unet_*), pas le montant de la ligne.
    if (this.is_ht) {
      net_taxx = parseFloat(line.get('unet_taxx')?.value) || 0;
      net_taxi = uprice_taxx ? roundHalfAway((net_taxx * uprice_taxi) / uprice_taxx, 4) : 0;
      flatdiscount = round_currency(uprice_taxx - net_taxx);
      percentdiscount = uprice_taxx ? round_currency((flatdiscount / uprice_taxx) * 100) : 0;
      line.get('unet_taxi')!.setValue(net_taxi);
    } else {
      net_taxi = parseFloat(line.get('unet_taxi')?.value) || 0;
      net_taxx = uprice_taxi ? roundHalfAway((net_taxi * uprice_taxx) / uprice_taxi, 4) : 0;
      flatdiscount = round_currency(uprice_taxi - net_taxi);
      percentdiscount = uprice_taxi ? round_currency((flatdiscount / uprice_taxi) * 100) : 0;
      line.get('unet_taxx')!.setValue(net_taxx);
    }

    line.get('spl')?.setValue(null);
    (line as FormGroup).setControl('lnk_spl', new FormControl(null));
    this.lineFlatDiscounts[i] = flatdiscount;
    this.linePercentDiscounts[i] = percentdiscount;
    // line.get('typ')!.setValue(2);
    this.processTotal();
  }

  // Add new Sales_payment to lnk_payment
  internalAddPayment(method: number, amount: number) {
    //console.log(`[internalAddPayment] ${amount}`);
    const lnk_receivables = this.formGroup.get('lnk_receivables') as FormArray; // All receivables
    let customerRecCtrl = lnk_receivables.controls.find(c => c.value.payer_id === this.formGroup.value.customer); // find customer receivable

    if (customerRecCtrl) {
      const payments = customerRecCtrl.get('lnk_receivable_payments') as FormArray; // payments of customer receivable
      payments.push(
        Sales_receivable_payment.asFormGroup({
          id_receivable: customerRecCtrl.value.id, // Customer receivable id
          id_payment: 0, // Creation => no id
          amount: +amount,
          lnk_payment: Object.assign(new Sales_payment(), {
            id: 0,
            customer: this.formGroup.getRawValue().customer,
            station: this.formGroup.value.station,
            id_user: this.formGroup.value.id_user,
            amount: +amount,
            method: +method,
            dat: new Date(),
            data: { comment: this.paymentdataComment.value },
          }),
        }),
      );
    } else {
      console.warn('No customer receivable found to attach payment');
    }

    this.processRemainder();
    this.paymentinput.setValue('');
    this.paymentdataComment.setValue('');
  }

  onSellout() {
    // Push sellout Button => Add payment for remainder (if any) value AND change status to PAID
    if (!this.is_visible(2) || !this.isPaymentEntryVisible) return; // Pièce scellée ou commande : la saisie de règlement est fermée
    if (+this.paymenttype.value === 4) {
      this.onOpenUseAvoirDialog();
      return;
    }
    if (this.refusesLockedCash()) return;
    if (this.formGroup.value.doc_type === DocType.TICKET && Number(this.formGroup.get('amount_taxi')?.value || 0) < 0) {
      this.alertService.error('Un ticket de caisse ne peut pas avoir un montant total négatif. Veuillez créer un Avoir.');
      return;
    }
    if (this.remainder > 0) this.internalAddPayment(this.paymenttype.value, this.remainder);
    this.formGroup.patchValue({ state: SalesOrderState.PAID }); // PAID state is determined by server. The sent value is ignored
    this.onSubmit.emit(); // Emit submit to parent => Save Order
  }

  /**
   * @description Remboursement du client en espèces pour solder l'Avoir.
   * Requalifie le document en Avoir, enregistre le décaissement en espèces
   * et transmet l'ordre de règlement pour passage à l'état PAYÉ.
   */
  onRefundCash(): void {
    if (!this.isPaymentEntryVisible) return;
    const currentData = this.formGroup.get('data')?.value || this.formGroup.value?.data || {};
    this.formGroup.patchValue({
      doc_type: DocType.AVOIR,
      data: { ...currentData, refund_mode: 'CASH' }
    });

    // Mode de paiement Espèces en dur (c_values 7 « Modes de paiement » : id 2 = Espèces, id 1 = Carte bancaire depuis le 30/09/2026).
    // Ne pas utiliser m.data?.code qui sert uniquement aux anciens codes de migration Orthop.
    const cashMethodId = 2;

    // Montant absolu à décaisser : priorité au reste à solder (this.remainder) calculé sur les créances,
    // avec repli sur le montant total TTC de la commande (amount_taxi) si les créances ne sont pas encore créées (brouillon CREATED).
    const absAmt = Math.abs(this.remainder || this.formGroup.value.amount_taxi || 0);
    if (absAmt <= 0) return;

    const lnk_receivables = this.formGroup.get('lnk_receivables') as FormArray;
    // Recherche de la créance propre au client/patient (payer_id === customer) parmi les créances
    // (pour distinguer la part patient des éventuelles parts tiers-payeurs AMO/AMC).
    const customerRecCtrl = lnk_receivables?.controls.find(c => (c.value?.payer_id || 0) === (this.formGroup.value?.customer || 0)) ?? lnk_receivables?.at(0);

    if (customerRecCtrl) {
      // 1. Les créances existent déjà (PREPARATION) : on affecte directement le règlement négatif à la créance client et on solde.
      this.quotationservice.pendingAvoirAction = null;
      this.internalAddPayment(cashMethodId, -absAmt);
      this.formGroup.patchValue({ state: SalesOrderState.PAID });
      this.onSubmit.emit();
    } else {
      // 2. Brouillon sans créances générées (CREATED) : on bascule vers PREPARATION pour matérialiser les créances côté serveur,
      // puis le composant parent enchaîne automatiquement la suite du remboursement en espèces.
      this.quotationservice.pendingAvoirAction = 'REFUND_CASH';
      this.quotationservice.pendingAvoirOrderId = Number(this.formGroup.get('id')?.value || 0); // l'action ne vaut que pour cette pièce
      this.formGroup.patchValue({ state: SalesOrderState.PREPARATION });
      this.onSubmit.emit();
    }
  }

  /**
   * @description Émission de l'Avoir sans décaissement immédiat (porté au crédit du client / bon d'avoir).
   * Requalifie le document en Avoir et le scelle à l'état INVOICED sans règlement fictif,
   * laissant sa créance négative en état OPEN (disponible pour imputation ultérieure).
   */
  onEmitAvoirOnly(): void {
    if (!this.isPaymentEntryVisible) return;
    const currentData = this.formGroup.get('data')?.value || this.formGroup.value?.data || {};
    this.formGroup.patchValue({
      doc_type: DocType.AVOIR,
      data: { ...currentData, refund_mode: 'AVOIR_ONLY' }
    });

    // Montant absolu à créditer : solde restant sur la créance cliente ou total TTC du document en brouillon.
    const absAmt = Math.abs(this.remainder || this.formGroup.value.amount_taxi || 0);
    if (absAmt <= 0) return;

    const lnk_receivables = this.formGroup.get('lnk_receivables') as FormArray;
    // Recherche de la créance propre au client/patient (payer_id === customer) parmi les créances
    // (pour distinguer la part patient des éventuelles parts tiers-payeurs AMO/AMC).
    const customerRecCtrl = lnk_receivables?.controls.find(c => (c.value?.payer_id || 0) === (this.formGroup.value?.customer || 0)) ?? lnk_receivables?.at(0);

    if (customerRecCtrl) {
      // 1. Les créances existent déjà (PREPARATION) : on scelle l'Avoir à l'état INVOICED sans règlement fictif.
      this.quotationservice.pendingAvoirAction = null;
      this.formGroup.patchValue({ state: SalesOrderState.INVOICED });
      this.onSubmit.emit();
    } else {
      // 2. Brouillon sans créances générées (CREATED) : on bascule vers PREPARATION pour matérialiser les créances côté serveur,
      // puis le composant parent enchaîne automatiquement la finalisation de l'Avoir à l'état INVOICED.
      this.quotationservice.pendingAvoirAction = 'AVOIR_ONLY';
      this.quotationservice.pendingAvoirOrderId = Number(this.formGroup.get('id')?.value || 0); // l'action ne vaut que pour cette pièce
      this.formGroup.patchValue({ state: SalesOrderState.PREPARATION });
      this.onSubmit.emit();
    }
  }

  /**
   * Ouvre la modale d'imputation d'un avoir disponible sur la commande courante.
   */
  onOpenUseAvoirDialog(): void {
    const orderId = Number(this.formGroup?.value?.id || 0);
    if (orderId <= 0) {
      this.alertService.warn("Veuillez d'abord enregistrer et valider le document avant d'imputer un avoir.");
      return;
    }
    const customerId = Number(this.formGroup?.value?.customer || 0);
    const customerName = this.customer ? `${this.customer.firstname ?? ''} ${this.customer.name ?? ''}`.trim() : '';
    const initialAmt = Number(this.paymentinput.value);

    const dialogData: UseAvoirDialogData = {
      orderId,
      customerId,
      customerName: customerName || undefined,
      remainder: this.remainder,
      initialAmount: initialAmt > 0 ? initialAmt : undefined,
      initialComment: this.paymentdataComment.value || undefined,
    };

    this.dialog
      .open(UseAvoirDialogComponent, {
        width: '680px',
        maxWidth: '95vw',
        data: dialogData,
      })
      .afterClosed()
      .subscribe(result => {
        if (result) {
          this.paymentinput.setValue('');
          this.paymentdataComment.setValue('');
          this.onReload.emit();
        }
      });
  }

  onCancel(): void {}

  onCancelPayment(recIndex: number, lineIndex: number): void {
    const lnk_receivables = this.formGroup.get('lnk_receivables') as FormArray;
    const recCtrl = lnk_receivables.at(recIndex);
    if (recCtrl) {
      const payments = recCtrl.get('lnk_receivable_payments') as FormArray;
      const paymentCtrl = payments.at(lineIndex);
      if (paymentCtrl && this.canCancelPaymentLine(paymentCtrl.value)) {
        const lnkPaymentCtrl = paymentCtrl.get('lnk_payment');
        if (lnkPaymentCtrl) {
          const lnkPaymentVal = lnkPaymentCtrl.value;
          lnkPaymentVal.action = 'CANCEL';
          lnkPaymentCtrl.patchValue(lnkPaymentVal);

          this.processRemainder();
          this.onSubmit.emit();
        }
      }
    }
  }

  /**
   * Vérifie si un règlement peut faire l'objet d'une substitution de mode de paiement.
   * - Le document est soldé (remainder === 0).
   * - Ce n'est pas un document de migration (isReadOnly).
   * - La ligne de paiement est un règlement initial valide (non annulé, amount > 0, id > 0).
   */
  canSubstitutePayment(line: any): boolean {
    if (this.isReadOnly) return false;
    if (this.remainder !== 0) return false;
    const payment = line?.lnk_payment;
    if (!payment || payment.action === 'CANCEL') return false;
    if (!payment.id || payment.id <= 0) return false;
    if (Number(line.amount || payment.amount || 0) <= 0) return false;
    return true;
  }

  /**
   * Ouvre la modale de substitution du mode de règlement.
   * Après substitution réussie, propose l'impression du ticket rectificatif (Point 4)
   * et déclenche le rechargement de la commande.
   */
  onOpenSubstitutePayment(line: any): void {
    const payment = line?.lnk_payment;
    if (!payment) return;

    const methodLabel = this.map_paymentmethods?.get(payment.method) || `Mode #${payment.method}`;
    const dialogData: SubstitutePaymentDialogData = {
      orderId: this.formGroup.value.id,
      originalPayment: {
        id: payment.id,
        method: payment.method,
        amount: Number(line.amount || payment.amount),
        methodLabel,
        comment: payment.data?.comment,
      },
    };

    this.dialog
      .open(SubstitutePaymentDialogComponent, {
        width: '540px',
        data: dialogData,
      })
      .afterClosed()
      .subscribe((result: any) => {
        if (result?.substituted) {
          this.alertService.success('Mode de règlement rectifié avec succès.');

          // Point 4: Impression à la demande
          Swal.fire({
            title: 'Règlement rectifié',
            text: 'Souhaitez-vous imprimer un justificatif de caisse rectificatif ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Imprimer',
            cancelButtonText: 'Fermer',
            confirmButtonColor: '#16a34a',
            cancelButtonColor: '#64748b',
          }).then((swalRes: any) => {
            if (swalRes.isConfirmed) {
              const orderId = this.formGroup?.value?.id;
              if (orderId) {
                this.printService
                  .getOrderJustificatif$(orderId, 'PRINT_TICKET_A4')
                  .subscribe({
                    next: (blob: Blob) => this.printService.printPdf(blob),
                    error: () => {
                      this.alertService.error("L'impression du justificatif a échoué.");
                    },
                  });
              }
            }
          });

          // Recharger le document pour rafraîchir l'historique des règlements
          this.onReload.emit();
        }
      });
  }

  onItemKeydown(e: any) {
    if (e.key === 'Enter') {
      // console.log(' salut from catch enter on quotation genera on onitemKeydown');
      e.preventDefault(); // Prevents form submit on Enter
      e.stopImmediatePropagation();
      e.target.blur();
    }
  }

  onClickSelectAll(e: any) {
    if (e && e.target && typeof e.target.select === 'function') e.target.select();
  } // ??

  onPaymentKeydown(e: any) {
    if (e.key === 'Enter') {
      e.preventDefault(); // Prevents form submit on Enter
      e.stopImmediatePropagation();
      this.onPayment();
    } else {
      this.paymentinput.setErrors({ incorrect: false });
    }
  }

  // Contrainte à l'écriture (BL et scellé lisent le mémo tel quel) : blancs de tête et de fin ôtés, un mémo blanc redevient ''.
  trimMemo(line: AbstractControl): void {
    const memo = line.get('memo');
    if (typeof memo?.value === 'string' && memo.value !== memo.value.trim()) memo.setValue(memo.value.trim());
  }

  onLineKeydown(e: any, i: number) {
    if (e.key === 'Enter') {
      e.preventDefault(); // Prevents form submit on Enter
      e.stopImmediatePropagation();
      this.onPriceQtyBlur(i);
    } else {
    }
  }

  onPayment() {
    // Push on payment button => Trigger addPayment w/ input value
    // console.log('this.paymentinput.value', this.paymentinput.value);
    // console.log('this.remainer', this.remainer);
    // console.log('this.paymenttype.value', this.paymenttype.value);
    if (!this.is_visible(2) || !this.isPaymentEntryVisible) return; // Pièce scellée ou commande : la saisie de règlement est fermée
    if (+this.paymenttype.value === 4) {
      this.onOpenUseAvoirDialog();
      return;
    }
    if (!this.paymentinput.value) return;
    if (this.refusesLockedCash()) return;
    if (!this.hasDrawer && this.paymentinput.value > this.remainder) {
      this.alertService.error('Rendu de monnaie impossible. ' + CASH_NEEDS_DRAWER); // le serveur rendrait l'excédent en espèces, sur ce poste
      return;
    }

    if (this.formGroup.value.doc_type === DocType.TICKET && Number(this.formGroup.get('amount_taxi')?.value || 0) < 0) {
      this.alertService.error('Un ticket de caisse ne peut pas avoir un montant total négatif. Veuillez créer un Avoir.');
      return;
    }

    // Check if the payment is valid (not too high) and if we can refund  this is also checked on server side
    let totalCash = this.paymenttype.value == 2 ? parseFloat(this.paymentinput.value) : 0; // 2 = Espèces (c_values 7) : if we add cash totalCash take the value we add  else 0

    const customerReceivable = this.formGroup.value.lnk_receivables?.find((r: any) => r.payer_id === this.formGroup.value.customer);
    if (customerReceivable && customerReceivable.lnk_receivable_payments) {
      const payments = customerReceivable.lnk_receivable_payments;
      for (let i = 0; i < payments.length; i++) {
        if (payments[i].lnk_payment?.method == 2) {
          totalCash += parseFloat(payments[i].amount);
        }
      }
    }
    // console.log('totalCash', totalCash);
    // console.log('this.remainder', this.remainder);
    if (this.paymentinput.value > this.remainder && this.paymentinput.value - this.remainder > totalCash) {
      // if we add a payment and the value is greater than the remainder and the value we add is greater than the totalCash we refuse the payment
      // console.log("Blocked payment [remainer / payment / type] = [" + this.remainer + " / " + this.paymentinput.value + " / " + this.paymenttype.value)
      this.alertService.error('Montant saisit trop important, ne peut être rendu en espèce');
    } else {
      this.internalAddPayment(this.paymenttype.value, this.paymentinput.value);
      this.formGroup.patchValue({ state: SalesOrderState.PAID }); // Force PAID state on first payment(possibly partially paid). Ignored by server/ THe server is responsible for state change
      this.onSubmit.emit(); // Emit submit to parent => Save Order
    }
  }

  onConfiguration(line: AbstractControl) {
    // Click on line product configuration button  line is the parent line
    // console.log(line);
    // console.log('value of line.value?.data?.cufs[constants.C_CUF_CONFIGURATION .toString()]  =  ', line.value?.data?.cufs[constants.C_CUF_CONFIGURATION.toString()]);
    // console.log('value of line.value =  ', line.value);

    // Le bouton « Configurer » n'était conditionné que par is_configurable_line : sans test
    // d'état, le dialogue (modal non fermable) pouvait réécrire les lignes enfants d'un
    // document scellé — il insère, supprime et patche dans le FormArray.
    if (!isOrderLineEditable(this.formGroup?.value?.state, this.formGroup?.value?.doc_type)) return;
    let lineg = line as FormGroup;
    if (line && line.value && line.value.data && line.value.data.cufs && line.value.data.cufs[constants.C_CUF_CONFIGURATION.toString()]) {
      this.openConfigurationDialog(line.value?.data?.cufs[constants.C_CUF_CONFIGURATION.toString()], line.value, (data: any) => {
        // data is undefined on configuration - cancel
        // console.log('value of data =  ' , data  );
        // let data_parent_line =line.value.data ;
        // if(data && data.cufs && data.cufs[constants.C_CUF_CONFIGURATION_VALUE] && Array.isArray(data.cufs[constants.C_CUF_CONFIGURATION_VALUE])){
        //   data_parent_line.cufs [this.C_CUF_CONFIGURATION_VALUE] =[]
        //   data.cufs[constants.C_CUF_CONFIGURATION_VALUE].forEach(prod_conf =>{
        //     console.log('value of prod_conf =  ' , prod_conf  );
        //     data_parent_line.cufs [this.C_CUF_CONFIGURATION_VALUE].push( { id_node:prod_conf.id_node ,order_node: prod_conf.lnk_node_order_val?.id , name: prod_conf.name, nlevel:prod_conf.nlevel , path : prod_conf.path, seq :prod_conf.seq, product: prod_conf?.lnk_product?.id  })
        //     let line_exist=false;
        //     this.lines.controls.forEach((control_l, index) => {
        //       const line = control_l as FormGroup;
        //       console.log('value of line =  ' , line.value  );
        //       console.log('value of line.get(typ) =  ' , line.get('typ')?.value  );
        //       if ( line.get('seq')?.value === prod_conf.seq) {
        //         line_exist = true
        //         console.log(' salut from line exist');
        //         if(prod_conf.lnk_product == null ||prod_conf.lnk_product == 'null' ){
        //           this.deleteLine(index)
        //         } else {
        //           line.patchValue({
        //             product: prod_conf.lnk_product.id,
        //             // product_barcode : conf_prod.lnk_product.
        //             template: prod_conf.lnk_product.template,
        //             product_name: prod_conf.lnk_product.name,
        //             qty:1,
        //           });
        //         }
        //       }
        //     });
        //     if (!line_exist && prod_conf.lnk_product && prod_conf.lnk_product.id){
        //       console.log(' salut from we create a new line in order');
        //       // data_parent_line.cufs [this.C_CUF_CONFIGURATION_VALUE].push( { id_node:prod_conf.id_node ,order_node: prod_conf.lnk_node_order_val?.id , name: prod_conf.name, nlevel:prod_conf.nlevel , path : prod_conf.path, seq :this.lines.length+1, product: prod_conf?.lnk_product?.id  })
        //       this.lines.push(Sales_order_l.asFormGroup( { id:0, typ : constants.SALES_ORDER_LINE_TYPE_COMPONENT_OF_CONFIG, id_order:0, product:prod_conf.lnk_product.id, template:prod_conf.lnk_product.template, qty:1, packaging_qtybaseuom:1,product_name:prod_conf.lnk_product.name,  vat: line.value.vat, vat_rate: line.value.vat_rate  , seq:this.lines.length+1  , uprice_taxi:0,uprice_taxx:0,net_taxi:0, net_taxx:0 , data: {}  } ) )
        //       if ( data_parent_line.cufs && data_parent_line.cufs [this.C_CUF_CONFIGURATION_VALUE]  && Array.isArray(data_parent_line.cufs [this.C_CUF_CONFIGURATION_VALUE])  ) {
        //         (data_parent_line.cufs [this.C_CUF_CONFIGURATION_VALUE].find( (parent_conf :any) => parent_conf.id_node == prod_conf.id_node )).seq = this.lines.length+1
        //       }
        //       console.log('value of data_parent_line =  ' , data_parent_line  );
        //     }
        //   })
        //   lineg?.controls['data'].patchValue(data_parent_line);	// Update line.data
        // }
      });
    }
  }

  openConfigurationDialog(configpath: string, parent_line: any, cb: Function) {
    // values is the parent line
    if (!isOrderLineEditable(this.formGroup?.value?.state, this.formGroup?.value?.doc_type)) return; // 2e appelant : addLine
    console.log('value of parent_line =  ', parent_line);
    const dialogRef = this.dialog.open(ConfigurationComponent, {
      disableClose: true, //  très important la modal ne peux se fermer que lorsqu'on a validé ce qui permet de bien créer la data dans la ligne parent_line et ainsi réserver les seq
      width: '80%',
      height: '80%',
      data: { mode: 'DIALOG', configpath: configpath, parent_line: parent_line },
    });
    this.configurationSubscription = dialogRef.afterClosed().subscribe((data: any) => {
      // result could be undefined
      console.log('value of data =  ', data);
      console.log('value of parent_line =  ', parent_line);
      let data_parent_line = parent_line.data;

      if (data && data.cufs && data.cufs[constants.C_CUF_CONFIGURATION_VALUE] && Array.isArray(data.cufs[constants.C_CUF_CONFIGURATION_VALUE])) {
        data_parent_line.cufs[this.C_CUF_CONFIGURATION_VALUE] = [];
        // console.log('value of  data.cufs[constants.C_CUF_CONFIGURATION_VALUE] =  ', data.cufs[constants.C_CUF_CONFIGURATION_VALUE]);
        data.cufs[constants.C_CUF_CONFIGURATION_VALUE].forEach(prod_conf => {
          // console.log('value of prod_conf =  ', prod_conf);
          data_parent_line.cufs[this.C_CUF_CONFIGURATION_VALUE].push({ id_node: prod_conf.id_node, order_node: prod_conf.lnk_node_order_val?.id, order_node_name: prod_conf.lnk_node_order_val?.name, name: prod_conf.name, nlevel: prod_conf.nlevel, path: prod_conf.path, seq: prod_conf.seq, product: prod_conf?.lnk_product?.id });
          let line_exist = false;
          // console.log('value of this.lines.value =  ', this.lines.value);
          this.lines.controls.forEach((control_l, index) => {
            const line = control_l as FormGroup;
            // console.log('value of line =  ', line.value);
            // console.log('value of line.get(typ) =  ', line.get('typ')?.value);
            if (line.get('seq')?.value === prod_conf.seq) {
              line_exist = true;
              // console.log(' salut from line exist');
              if (prod_conf.lnk_product == null || prod_conf.lnk_product == 'null') {
                this.deleteLine(line);
                // this.deleteLine(index)
              } else {
                // La ligne change de produit : son conditionnement suit, sinon elle garderait celui de l'ancien produit.
                line.patchValue({
                  product: prod_conf.lnk_product.id,
                  ppv: null,
                  template: prod_conf.lnk_product.template,
                  product_name: prod_conf.lnk_product.name,
                  qty: 1,
                });
                this.patchDefaultPpv(line, prod_conf.lnk_product.id);
              }
            }
          });
          if (!line_exist && prod_conf.lnk_product && prod_conf.lnk_product.id) {
            // console.log(' salut from we create a new line in order');
            // console.log('value of data_parent_line =  ', data_parent_line);

            // data_parent_line.cufs [this.C_CUF_CONFIGURATION_VALUE].push( { id_node:prod_conf.id_node ,order_node: prod_conf.lnk_node_order_val?.id , name: prod_conf.name, nlevel:prod_conf.nlevel , path : prod_conf.path, seq :this.lines.length+1, product: prod_conf?.lnk_product?.id  })
            const newLine = Sales_order_l.asFormGroup({ id: 0, typ: OrderLineType.COMPONENT, id_order: 0, product: prod_conf.lnk_product.id, template: prod_conf.lnk_product.template, qty: 1, packaging_qtybaseuom: 1, product_name: prod_conf.lnk_product.name, vat: parent_line.vat, vat_rate: parent_line.vat_rate, seq: prod_conf.seq, uprice_taxi: 0, uprice_taxx: 0, net_taxi: 0, net_taxx: 0, data: {} });
            this.patchDefaultPpv(newLine, prod_conf.lnk_product.id); // Le dialogue rend un produit, pas un conditionnement

            const insertIndex = this.lines.controls.findIndex(ctrl => ctrl.value.seq > prod_conf.seq); // Cherche la bonne position où insérer selon seq

            if (insertIndex === -1) {
              this.lines.push(newLine);
            } // Si on ne trouve pas de valeur supérieure, on insère à la fin
            else {
              this.lines.insert(insertIndex, newLine);
            }

            // console.log('value of data_parent_line =  ', data_parent_line);
          }
        });
        const targetSeq = parent_line.seq;
        const parentlineToUpdate = this.lines.controls.find((ctrl: AbstractControl) => ctrl.value.seq === parent_line.seq);
        if (parentlineToUpdate) {
          parentlineToUpdate.patchValue({ data: data_parent_line });
        }
        // let lineg = parent_line as FormGroup;
        // lineg?.controls['data'].patchValue(data_parent_line);	// Update line.data
      }

      console.log('this.lines', this.lines);

      if (data?.selectedSectionProducts?.length) {
        const maxSeq = Math.max(...this.lines.controls.map(c => c.value.seq ?? 0));
        data.selectedSectionProducts.forEach((prod: any, index: number) => {
          console.log('prod', prod);
          const newLine = Sales_order_l.asFormGroup({
            id: 0,
            typ: OrderLineType.ITEM,
            id_order: 0,
            product: prod.id,
            template: prod.template,
            qty: 1,
            packaging_qtybaseuom: 1,
            product_name: prod.name,
            vat: prod.lnk_template.vat,
            vat_rate: prod.lnk_template.vat_rate,
            seq: this.highestSeq() + 1,
            uprice_taxi: isNaN(Number(prod.price_taxi)) ? 0 : Number(prod.price_taxi),
            uprice_taxx: isNaN(Number(prod.price_taxx)) ? 0 : Number(prod.price_taxx),
            // Colisage 1 : prix du conditionnement = prix unitaire ; net_* (montant de ligne) est posé par processTotal.
            unet_taxi: isNaN(Number(prod.price_discounted_taxi)) ? (isNaN(Number(prod.price_taxi)) ? 0 : Number(prod.price_taxi)) : Number(prod.price_discounted_taxi),
            unet_taxx: isNaN(Number(prod.price_discounted_taxx)) ? (isNaN(Number(prod.price_taxx)) ? 0 : Number(prod.price_taxx)) : Number(prod.price_discounted_taxx),
            net_taxi: 0,
            net_taxx: 0,
            data: { ...prod.data },
          });
          this.patchDefaultPpv(newLine, prod.id); // Vente additionnelle : ligne ITEM facturée, elle désigne un conditionnement comme les autres
          this.lines.push(newLine);
          this.initLineDiscounts();
          this.processTotal();
        });
      }

      // if (data?.selectedSectionProducts?.length) {
      // 	// const maxSeq = Math.max(...this.lines.controls.map(c => c.value.seq ?? 0));
      // 	data.selectedSectionProducts.forEach((prod: any, index: number) => {
      // 		// const newLine = Sales_order_l.asFormGroup({ id: 0, typ: constants.SALES_ORDER_LINE_TYPE_COMPONENT_OF_CONFIG, id_order: 0, product: prod.id, template: prod.template, qty: 1, packaging_qtybaseuom: 1, product_name: prod.name, vat: parent_line.vat, vat_rate: parent_line.vat_rate, seq: maxSeq + index + 1, uprice_taxi: 0, uprice_taxx: 0, net_taxi: 0, net_taxx: 0, data: {} });
      // 		this.lines.push({
      // 						product:  prod.id,
      // 						typ:8,
      // 						// product_barcode : conf_prod.lnk_product.
      // 						template:  prod.template,
      // 						product_name:  prod.name,
      // 						qty: 1,
      // 					});
      // 	});
      // }

      //   // this.openConfigurationDialog(ppv?.lnk_product?.data?.cufs[constants.C_CUF_CONFIGURATION], this.lines.at(-1).value , (data:any) => {
      // // this.addLine(ppv, qty, data); // before we add line after create config pb we don't have the seq of parent
      // if(data && data.cufs && data.cufs[this.C_CUF_CONFIGURATION_VALUE] && Array.isArray( data.cufs[this.C_CUF_CONFIGURATION_VALUE] )  && this.lines.value.length > 0  ){
      //   console.log('value of data.cufs[this.C_CUF_CONFIGURATION_VALUE].lnk_sol. =  ' , data.cufs[this.C_CUF_CONFIGURATION_VALUE].lnk_sol );
      //   // ici on a des lignes d order dans la config
      //   let parent_line = this.lines.value.at(-1);
      //   const parent_index = this.lines.length -1 ;
      //   let data_parent_line =this.lines.value.at(-1).data ;
      //   console.log('value of parent_line =  ' , parent_line  );
      //   if( !data_parent_line.cufs || ! data_parent_line.cufs[this.C_CUF_CONFIGURATION_VALUE] || ! Array.isArray(data_parent_line.cufs[this.C_CUF_CONFIGURATION_VALUE]   ) ) {
      //     data_parent_line.cufs [this.C_CUF_CONFIGURATION_VALUE] =[]
      //   }
      //   data.cufs[this.C_CUF_CONFIGURATION_VALUE].forEach((prod_conf:IProductConfig)  =>{
      //     console.log('value of prod_conf =  ' , prod_conf  );
      //     if(prod_conf && prod_conf.lnk_node_order_val && prod_conf.lnk_product){
      //       data_parent_line.cufs [this.C_CUF_CONFIGURATION_VALUE].push( { id_node:prod_conf.id_node ,order_node: prod_conf.lnk_node_order_val?.id , name: prod_conf.name, nlevel:prod_conf.nlevel , path : prod_conf.path, seq :this.lines.length+1, product: prod_conf?.lnk_product?.id  })
      //       this.lines.push(Sales_order_l.asFormGroup( { id:0, typ : constants.SALES_ORDER_LINE_TYPE_COMPONENT_OF_CONFIG, id_order:0, product:prod_conf.lnk_product.id, template:prod_conf.lnk_product.template, qty:1, packaging_qtybaseuom:1,product_name:prod_conf.lnk_product.name,  vat: ppv.lnk_product.lnk_template.vat, vat_rate: ppv.lnk_product.lnk_template.vat_rate  , seq:this.lines.length+1  , uprice_taxi:0,uprice_taxx:0,net_taxi:0, net_taxx:0 , data: {}  } ) )
      //     }
      //   })
      //   // maintenant on va mettre a jour le parent mais il faut d'abord le retrouver car ce n'est plus le dernier on utilise son seq pour le retrouver
      //   this.lines.at(parent_index).patchValue({data: data_parent_line })
      //   console.log('value of data_parent_line =  ' , data_parent_line  );
      //   // this.lines.at().get('qty')?.setValue(10);
      // }
      // console.log('value of this.lines =  ' , this.lines  );

      cb(data);
      // console.log('The dialog was closed: ' + JSON.stringify(newcustomer));
      // this.selectCustomer(newcustomer);
    });
  }

  // Customer change => recalculate all line prices with new customer pricelists
  customerChange() {
    // Défense en profondeur : réécrit unet_taxi/unet_taxx/spl des lignes. Inatteignable
    // en consultation (le sélecteur client est verrouillé en amont), mais la fonction
    // elle-même n'était protégée par rien.
    if (!isOrderLineEditable(this.formGroup?.value?.state, this.formGroup?.value?.doc_type)) return;
    if (this.lines.controls.length === 0) return;
    forkJoin(
      this.lines.controls.map(l => {
        // Les lignes de location sortent de la re-tarification : leur prix vient du contrat (rental_terms), pas du
        // catalogue. Avant la bascule, partnbloc rangé dans product_barcode faisait échouer jbc: et protégeait par accident.
        if (l.get('rental_terms_snapshot')?.value != null || l.get('rental_terms')?.value != null) return of(null);
        if (l.get('typ')?.value === OrderLineType.COMPONENT) return of(null); // un composant est compris dans le prix de l'article configuré (créé à 0)
        // Re-tarifer se fait PAR PRODUIT (jpid:) : aucune règle tarifaire ne porte sur le conditionnement, les quatre
        // champs patchés sortent de lnk_product ; le prix unitaire est remultiplié par le packaging_qtybaseuom déjà posé sur la ligne.
        return this.productsService.search_productpackaging('jpid', l.get('product')?.value, this.customer?.data?.pricelists).pipe(
          map((ppv: any) => {
            if (ppv) {
              const pack = Number(l.get('packaging_qtybaseuom')?.value) || 1;
              let newprice_taxi = ppv.price_discounted_taxi ? ppv.price_discounted_taxi : ppv.lnk_product?.price_taxi;
              let newprice_taxx = ppv.price_discounted_taxx ? ppv.price_discounted_taxx : ppv.lnk_product?.price_taxx;
              l.get('unet_taxi')?.patchValue(roundHalfAway(Number(newprice_taxi) * pack, 4));
              l.get('unet_taxx')?.patchValue(roundHalfAway(Number(newprice_taxx) * pack, 4));
              l.get('spl')?.patchValue(ppv.lnk_product?.spl);
              (l as FormGroup).setControl('lnk_spl', new FormControl(this.find_lnk_spl(ppv)));
            }
          }),
        );
      }),
    ).subscribe(() => {
      this.processTotal();
      this.initLineDiscounts();
    });
  }

  ngOnDestroy() {
    if (this.isHtSubscription) this.isHtSubscription.unsubscribe();
    if (this.eventsSubscription) this.eventsSubscription.unsubscribe();
    if (this.quotationSubscription) this.quotationSubscription.unsubscribe();
    if (this.configurationSubscription) this.configurationSubscription.unsubscribe();
    if (this.formGroupChangeSubscription) this.formGroupChangeSubscription.unsubscribe();
    if (this.customerEventsSubscription) this.customerEventsSubscription.unsubscribe();
    if (this.memoAutosizesSubscription) this.memoAutosizesSubscription.unsubscribe();
  }

  // 1 : zone financière en LECTURE (créances tiers payeurs, règlements déjà enregistrés,
  //     reste à payer). 2 : SAISIE d'un règlement (ajout, solde, annulation).
  //
  // Les deux étaient confondus, si bien qu'une pièce reprise n'affichait RIEN du financier :
  // ni les créances AMO/AMC/client remontées d'orthop, ni ce qui avait été réglé, ni le
  // reste dû. Pour un écran de consultation c'était le pire des cas — on montre donc la
  // lecture, et on garde la saisie fermée.
  //
  // La saisie ne peut pas être ouverte à MIGRATION par un simple ajout ici : le serveur la
  // refuse à quatre niveaux (matrice de transitions sur le patch state=PAID du front, absence
  // de bras Migration dans process_order_update, et surtout le contrôle de cohérence
  // grand livre ↔ safe.order_payment de lifecycle.rs — une pièce reprise porte un
  // amount_paid sans aucune écriture safe.*, l'égalité est fausse par construction).
  // Cela demande un travail serveur, pas un réglage d'affichage.
  is_visible(section: number): boolean {
    const state = this.formGroup.get('state')?.value;
    switch (section) {
      case 1:
        return [SalesOrderState.PREPARATION, SalesOrderState.DELIVERED, SalesOrderState.INVOICED, SalesOrderState.PAID, SalesOrderState.MIGRATION].includes(state);
      case 2:
        return !isSealedOrder(state) && [SalesOrderState.PREPARATION, SalesOrderState.DELIVERED, SalesOrderState.PAID].includes(state);
      default:
        return false;
    }
  }

  // Pas de poubelle sur un règlement REPRIS (historique légal hors chaîne safe) ni sur une pièce soldée ; sur une commande,
  // l'acompte s'annule par son avoir, jamais par la poubelle. Dans tous les cas la ligne reste lisible.
  get isPaymentCancelable(): boolean {
    return this.is_visible(2) && this.isPaymentEntryVisible && this.remainder !== 0;
  }

  canCancelPaymentLine(line: any): boolean {
    if (!line?.lnk_payment || line.lnk_payment.action === 'CANCEL') return false;
    // Une imputation s'annule depuis la pièce réglée, jamais depuis l'avoir : le serveur y solderait la créance négative et le crédit serait perdu.
    if (+line.lnk_payment.method === 4 && this.formGroup?.get('doc_type')?.value === DocType.AVOIR) return false;
    if (this.isPaymentCancelable) return true;
    const state = this.formGroup?.get('state')?.value;
    return !isSealedOrder(state) && this.remainder !== 0 && +line.lnk_payment.method === 4;
  }

  // Sur une COMMANDE (doc_type FACTURE), le seul encaissement possible est « Encaisser un acompte »
  // de la barre d'action : la saisie libre de règlement disparaît. Comptoir et location inchangés.
  get isPaymentEntryVisible(): boolean {
    return this.formGroup?.value?.doc_type !== DocType.FACTURE;
  }

  get isProcessingAvoir(): boolean {
    return !!this.quotationservice?.pendingAvoirAction;
  }

  get pendingAvoirAction(): 'REFUND_CASH' | 'AVOIR_ONLY' | null {
    return this.quotationservice?.pendingAvoirAction || this.formGroup?.get('data')?.value?.refund_mode || null;
  }

  // Seul un poste à tiroir-caisse voit entrer ou sortir des espèces (encaissement, rendu monnaie).
  private get hasDrawer(): boolean {
    return isPosStation(this.loginService.currentstation);
  }

  // Back-stop de « Ajouter », « Solder » et de l'Entrée : griser une option ne ferme pas une méthode publique.
  private refusesLockedCash(): boolean {
    if (!this.isCashLocked({ id: this.paymenttype.value })) return false;
    this.alertService.error(CASH_NEEDS_DRAWER);
    return true;
  }

  // Une seule règle, nommée, pour tout ce qui touche aux lignes — au lieu du
  // `state === CREATED` répété dans le template et du SalesOrderHelper.isCreated au nom
  // inversé dans le TS. C'est le pendant template des gardes posées sur addLine, deleteLine,
  // addDiscountLine et onConfiguration.
  get isLineEditable(): boolean {
    return isOrderLineEditable(this.formGroup?.value?.state, this.formGroup?.value?.doc_type);
  }

  // Document repris de l'ancien ERP : consultation seule (bandeau, zone financière en lecture).
  get isReadOnly(): boolean {
    return isSealedOrder(this.formGroup?.value?.state);
  }

  get lines(): FormArray {
    return this.formGroup.controls['lines'] as FormArray;
  }

  get paylines(): FormArray | null {
    const lnk_receivables = this.formGroup.controls['lnk_receivables'] as FormArray;
    let customerRecCtrl = lnk_receivables.controls.find(c => c.value.payer_id === this.formGroup.value.customer);
    if (customerRecCtrl) {
      return customerRecCtrl.get('lnk_receivable_payments') as FormArray;
    }
    return null;
  }

  get linesControls(): FormGroup[] {
    // This is used to comply to TS type checking on formGroup
    return (this.formGroup.controls['lines'] as FormArray).controls as FormGroup[];
  }

  /**
   * Détermine si une ligne de document doit être affichée dans le tableau général de vente.
   *
   * Logique métier :
   * - Sur un contrat de location (`doc_type === DocType.LOCATION`), les lignes de location
   *   (`typ === 6`) sont affichées dans le composant dédié `app-rentgeneral`. Le tableau
   *   général fait alors office de « partie vente » et ne doit afficher que les articles
   *   standards (`typ <= 5`) pour éviter les doublons d'affichage.
   * - Sur tout autre document (notamment une `FACTURE` issue de la facturation périodique
   *   d'une location, un `TICKET` ou un `AVOIR`), `app-rentgeneral` n'est pas instancié.
   *   Le tableau général est le seul réceptacle des lignes et doit donc présenter
   *   l'intégralité des éléments facturés, y compris les lignes de location (`typ === 6`).
   *
   * @param line Le FormGroup ou contrôle représentant la ligne de vente/location.
   * @returns `true` si la ligne doit être rendue dans le tableau, `false` sinon.
   */
  is_line_visible(line: any): boolean {
    if (this.formGroup?.value?.doc_type === DocType.LOCATION) {
      const typ = line?.value ? line.value.typ : line?.typ;
      return typ !== OrderLineType.RENTAL && typ !== OrderLineType.RENTAL_RETURN && typ !== 6 && typ !== 7;
    }
    return true;
  }

  /**
   * Indique si la pièce contient au moins une ligne d'article de vente (ITEM).
   *
   * @returns `true` si au moins une ligne est de type ITEM, `false` sinon.
   */
  get hasItemLines(): boolean {
    if (!this.lines || this.lines.length === 0) {
      return false;
    }
    return this.lines.controls.some((ctrl: any) => {
      const typ = ctrl?.value ? ctrl.value.typ : ctrl?.typ;
      return typ === OrderLineType.ITEM || typ === 'ITEM' || typ === 1;
    });
  }

  /**
   * Détermine si le tableau de ventilation de la TVA doit être affiché dans l'interface.
   *
   * Règle de gestion :
   * - L'ordre doit être dans un état validé / non-création (`SalesOrderHelper.isCreated`).
   * - Dans le cadre d'un devis de location (`doc_type === DocType.LOCATION`), les lignes de location
   *   ne sont pas soumises à ventilation immédiate. Le panneau de TVA n'est affiché que si le
   *   devis comporte au moins une ligne d'article (ITEM).
   *
   * @returns `true` si le panneau TVA doit être affiché, `false` sinon.
   */
  get showVatPanel(): boolean {
    if (!SalesOrderHelper.isCreated(this.formGroup?.value?.state)) {
      return false;
    }
    if (this.formGroup?.value?.doc_type === DocType.LOCATION) {
      return this.hasItemLines;
    }
    return true;
  }

  /**
   * Détermine si le bloc des totaux (Total TTC, Total HT, Total TVA) doit être affiché.
   *
   * Règle de gestion :
   * - Sur un devis de location (`doc_type === DocType.LOCATION`), ce bloc ne doit pas s'afficher
   *   lorsque seuls des articles de location sont présents (ou aucun article de vente).
   * - Sur les autres types de documents, le bloc des totaux reste visible.
   *
   * @returns `true` si le bloc des totaux doit être affiché, `false` sinon.
   */
  get showTotalsBlock(): boolean {
    if (this.formGroup?.value?.doc_type === DocType.LOCATION) {
      return this.hasItemLines;
    }
    return true;
  }

  is_configurable_line(line: any): boolean {
    return line && line.value && line.value.data && line.value.data.cufs && line.value.data.cufs[constants.C_CUF_CONFIGURATION.toString()];
  }

  // Appelez ceci une fois que 'strategyDiscount' est chargé (ex: dans ngOnInit)
  getStrategyName(id: number): string {
    const strategy = this.strategyDiscount.find(sd => sd.id === id);
    return strategy && strategy.name ? strategy.name : '';
  }

  // « Dont éco-participation » par filière, pour information : déjà dans le prix net, jamais ajoutée au montant de la ligne.
  getEcopartLines(line: any): { code: string; amount: number }[] {
    const ecoparts: any[] | null = line?.ecoparts;
    if (!Array.isArray(ecoparts)) return [];
    const factor = this.is_ht ? 1 : 1 + (Number(line.vat_rate) || 0) / 100;
    const served = servedEcopartQty(ecoparts); // retenue par asFormGroup sur le tableau d'origine, pas sur le [val] ci-dessous
    const result: { code: string; amount: number }[] = [];
    ecoparts.forEach(val => {
      if (val === null || val === undefined) return;
      const taxx = lineEcopartTaxx(Number(line.qty) || 0, line.packaging_qtybaseuom, [val], served);
      if (taxx) result.push({ code: val.code ?? val.name ?? '', amount: roundHalfAway(taxx * factor, 2) });
    });
    return result;
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.formGroup.controls;
  }

  find_lnk_spl(ppv: ProductPackagingVal) {
    // console.log('ppvmm', ppv);
    const partnerPrices = ppv.lnk_product?.lnk_sales_partnerprices;
    if (!partnerPrices) return null;
    for (const sp of partnerPrices) {
      const spls = sp.lnk_salespartnerpricels;
      if (spls) {
        const found_spl = spls.find((spl: any) => spl.id === ppv.lnk_product?.spl);
        if (found_spl) {
          // si on trouve un sale patnerprice line qui corresopond
          found_spl.name = sp.name; // on prend le nom de son parent
          return found_spl; // Arrêt immédiat dès qu'on a trouvé
        }
      }
    }
    return null;
  }

  triggerHighlight(index: number): void {
    const group = this.lines.at(index) as FormGroup;
    if (!group.contains('_highlight')) {
      group.addControl('_highlight', new FormControl(true), { emitEvent: false } as any);
    } else {
      group.get('_highlight')!.setValue(true, { emitEvent: false });
    }
    setTimeout(() => {
      group.get('_highlight')?.setValue(false, { emitEvent: false });
    }, 2000);
  }
}

// Helper for SalesOrderState checking
//
// ⚠ LE NOM MENT : isCreated rend TRUE quand l'état n'est PAS « en création ». Il ne sert
// plus qu'à l'AFFICHAGE de la ventilation de TVA (quotationgeneral.component.html), où cette
// sémantique inversée est celle qu'on veut. Les quatre gardes d'ÉCRITURE qui l'utilisaient
// (quantité, remise en valeur, remise en %, prix net) sont passées à isOrderLineEditable
// (shared/constants.ts) : outre le nom honnête, cela ferme un trou — l'ancienne garde
// laissait passer CANCELED, une commande annulée restait donc éditable.
// Ne PAS étendre ce helper sans le renommer : il est utilisé en condition positive.
export const SalesOrderHelper = {
  isCreated(state: SalesOrderState): boolean {
    return ![SalesOrderState.CREATED, SalesOrderState.CANCELED].includes(state);
  },
};
